import type { HtmlType } from '../../types.js'
import { Block } from '../block.js'

export abstract class LogicBlock extends Block {
	canHaveChild(child: Block): boolean {
		if (!this.parent) return true

		return this.parent.canHaveChild(child)
	}

	canHaveParent(parent: Block | undefined): boolean {
		let nonLogicParent = parent
		while (nonLogicParent && !(nonLogicParent instanceof LogicBlock)) {
			nonLogicParent = nonLogicParent.parent
		}
		if (!nonLogicParent) return true

		if (this.children) {
			for (let child of this.children) {
				if (!child.canHaveParent(nonLogicParent)) {
					return false
				}
			}
		}

		return true
	}

	isLogicBlock(): this is LogicBlock {
		return true
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#ffb74d'
	}

	getTitleColor(): string {
		return '#4e2600'
	}

	getPreviewDirection() {
		return this.parent?.getPreviewDirection() ?? 'column'
	}
}
